import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-406184f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "game-base" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mercs, Mages & Monsters", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" A Tabletop Role Playing Game ("),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "TTRPG"),
  /*#__PURE__*/_createTextVNode(") based in medieval fantasy. Welcome to Yogath, where the old King is dead and the new one is mad. Our Lords maneuver for power while the schemers scheme. The guilds profit as our beloved Kingdom balances on a razor's edge. Shadows draw ever nearer, but the real questions is... how far would you go for coin?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3d8 system inspired by themes in "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "Symbaroum"),
  /*#__PURE__*/_createTextVNode(" / "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "Dark Heresy"),
  /*#__PURE__*/_createTextVNode(" and others. ")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}